import TabItem, { TabItemProps } from './TabItem';

export type { TabItemProps };
export default TabItem;
